export default function Message(props){


return <tr className="log-entry" onClick={() => props.selectedMessage(props.message.location)}>
    <td className="tstamp">{props.message.tstamp}</td>
    <td className="type" data-type={props.message.type.toLowerCase()}><span>{props.message.type}</span></td>
    <td className="message">{props.message.message}</td>
</tr>
}